<template>
  <div id="HeroBanner">
    <section class="hero is-black is-large video">
      <!-- <div class="hero-video">
        <video playsinline autoplay muted loop>
          <source src="@/assets/videos/hero_cover.mp4" type="video/mp4" />
        </video>
      </div> -->
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">SECRET STOREY</h1>
          <h2 class="subtitle">Sukhumvit24, Bangkok</h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HeroBanner"
};
</script>

<style></style>
